import * as types from '../type/type'

export const setToken = (token) => ({
  type: types.SET_TOKEN,
  payload: token,
})
